import React from 'react'
import styles from './Widget.module.css'

interface WidgetProps {
  children: React.ReactNode
  size?: 'small' | 'medium' | 'large'
  rounded?: boolean
  backgroundColor?: string
}

export default function Widget({ children, size = 'medium', rounded = true, backgroundColor }: WidgetProps) {
  const sizeClass = styles[size]
  const style = backgroundColor ? { backgroundColor } : {}

  return (
    <div className={`${styles.widget} ${sizeClass}`} style={style}>
      {children}
    </div>
  )
}
